<template>
  <div>
    <div class="d-flex justify-content-center">
      <table>
        <tr>
          <td class="functionzone"></td>
          <td class="functionzone"></td>
          <td class="dropzone" ref="dropzonePlace" id="dropzone1">
            <div
              style="text-align: center;margin: 0;border: #7f8c8d 1px solid;border-radius: 0.4vw;height: 95%;color: #00008B;"
              class="dropzone-drop"
            >{{ verticalNumbers[0] }}</div>
          </td>
          <td class="functionzone"></td>
          <td class="functionzone"></td>
        </tr>
        <tr>
          <td class="functionzone"></td>
          <td class="functionzone"></td>
          <td class="dropzone" id="dropzone2" ref="dropzonePlace2">
            <div
              style="text-align: center;margin: 0;border: #7f8c8d 1px solid;border-radius: 0.4vw;height: 95%;color: #00008B"
              class="dropzone-drop"
            >{{ verticalNumbers[1] }}</div>
          </td>
          <td class="functionzone"></td>
          <td class="functionzone"></td>
        </tr>
        <tr>
          <td class="dropzone" id="dropzone3" ref="dropzonePlace3">
            <div
              style="text-align: center;margin: 0;border: #7f8c8d 1px solid;border-radius: 0.4vw;height: 95%;color: #DC143C"
              class="dropzone-drop"
            >{{ horizontalNumbers[0] }}</div>
          </td>
          <td class="dropzone" id="dropzone4" ref="dropzonePlace4">
            <div
              style="text-align: center;margin: 0;border: #7f8c8d 1px solid;border-radius: 0.4vw;height: 95%;color: #DC143C"
              class="dropzone-drop"
            >{{ horizontalNumbers[1] }}</div>
          </td>

          <td class="dropzone" id="dropzone5" ref="dropzonePlace5">
            <div
              style="text-align: center;margin: 0;border: #7f8c8d 1px solid;border-radius: 0.4vw;height: 95%;color: #223254;"
              class="dropzone-drop dropzone-drop-middle"
            >{{ middleNumber}}</div>
          </td>

          <td class="dropzone" id="dropzone6" ref="dropzonePlace6">
            <div
              style="text-align: center;margin: 0;border: #7f8c8d 1px solid;border-radius: 0.4vw;height: 95%;color: #DC143C"
              class="dropzone-drop"
            >{{ horizontalNumbers[3] }}</div>
          </td>
          <td class="dropzone" id="dropzone7" ref="dropzonePlace7">
            <div
              style="text-align: center;margin: 0;border: #7f8c8d 1px solid;border-radius: 0.4vw;height: 95%;color: #DC143C"
              class="dropzone-drop"
            >{{ horizontalNumbers[4] }}</div>
          </td>
        </tr>
        <tr>
          <td class="functionzone"></td>
          <td class="functionzone"></td>
          <td class="dropzone" id="dropzone8" ref="dropzonePlace8">
            <div
              style="text-align: center;margin: 0;border: #7f8c8d 1px solid;border-radius: 0.4vw ;height: 95%;color: #00008B"
              class="dropzone-drop"
            >{{ verticalNumbers[3] }}</div>
          </td>
          <td class="functionzone"></td>
          <td class="functionzone"></td>
        </tr>
        <tr>
          <td class="functionzone"></td>
          <td class="functionzone"></td>

          <td class="dropzone" id="dropzone9" ref="dropzonePlace9">
            <div
              style="text-align: center;margin: 0;border: #7f8c8d 1px solid;border-radius: 0.4vw;height: 95%;color: #00008B"
              class="dropzone-drop"
            >{{ verticalNumbers[4] }}</div>
          </td>
          <td class="functionzone"></td>
          <td class="functionzone"></td>
        </tr>
      </table>
    </div>

    <div class="d-flex justify-content-center">
      <div>
        <app-number-block :number="1"></app-number-block>
        <app-number-block :number="2"></app-number-block>
        <app-number-block :number="3"></app-number-block>
        <app-number-block :number="4"></app-number-block>
        <app-number-block :number="5"></app-number-block>
        <app-number-block :number="6"></app-number-block>
        <app-number-block :number="7"></app-number-block>
        <app-number-block :number="8"></app-number-block>
        <app-number-block :number="9"></app-number-block>
      </div>
    </div>
  </div>
</template>

<script>
import interact from "interactjs";
import NumberBlock from "./NumberBlock";
export default {
  components: {
    appNumberBlock: NumberBlock,
  },
  props: [
    "middleNumber",
    "horizontalNumbers",
    "verticalNumbers",
    "pickMiddleNumber",
    "myMiddleNumber",
  ],
  watch: {
    pickMiddleNumber(value) {
      if (!value) {
        this.unsetDraggable();
        this.unsetDropzone();
      }
    },
    myMiddleNumber(value) {
      if (!value) {
        // console.log("reset");
        this.resetCrossTable();
      }
    },
  },
  methods: {
    /**
     * Set draggable
     */
    setDraggable() {
      interact(".app-number-block").draggable({
        intertia: false,
        autoScroll: true,
        onstart: this.handleDragStart,
        onmove: this.handleDragMove,
        onend: this.handleDragEnd,
      });
    },
    handleDragStart(e) {
      e.target.classList.add("app--number-selected");
    },
    handleDragMove(e) {
      let target = e.target;
      // keep the dragged position in the data-x/data-y attributes
      let x = (parseFloat(target.getAttribute("data-x")) || 0) + e.dx;
      let y = (parseFloat(target.getAttribute("data-y")) || 0) + e.dy;
      target.style.webkitTransform = target.style.transform =
        "translate(" + x + "px, " + y + "px)";
      // update the posiion attributes
      target.setAttribute("data-x", x);
      target.setAttribute("data-y", y);
    },
    handleDragEnd(e) {
      e.target.classList.remove("app--number-selected");
      e.target.style.webkitTransform = e.target.style.transform =
        "translate(0, 0)";
      e.target.removeAttribute("data-x");
      e.target.removeAttribute("data-y");
    },
    unsetDraggable() {
      interact(".app-number-block").unset();
    },
    // End of set draggable

    /**
     * Set Dropzone
     * */
    setDropzone() {
      interact(".dropzone-drop-middle").dropzone({
        accept: ".app--number-selected",
        overlap: 0.6,
        ondropactivate: function (event) {
          // add active dropzone feedback
          event.target.classList.add("drop-active");
        },
        ondragenter: function (event) {
          var draggableElement = event.relatedTarget;
          var dropzoneElement = event.target;

          // feedback the possibility of a drop
          dropzoneElement.classList.add("drop-target");
          //draggableElement.classList.add('can-drop')
          //draggableElement.textContent = 'Dragged in'
        },
        ondragleave: function (event) {
          // remove the drop feedback style
          event.target.classList.remove("drop-target");
          //event.relatedTarget.classList.remove('can-drop')
          //event.relatedTarget.textContent = 'Dragged out'
        },
        ondrop: this.handleDrop,
        ondropdeactivate: function (event) {
          // remove active dropzone feedback
          event.target.classList.remove("drop-active");
          event.target.classList.remove("drop-target");
        },
      });
    },
    handleDrop(event) {
      const draggableElement = event.relatedTarget;
      const dropzoneElement = event.target;
      const numberBlocksEl = document.getElementsByClassName(
        "app-number-block"
      );
      dropzoneElement.textContent = draggableElement.textContent;
      for (let el of numberBlocksEl) {
        el.classList.remove("dropped");
      }
      draggableElement.classList.add("dropped");
      this.$emit("setMiddleNumber", Number(draggableElement.textContent));
    },
    unsetDropzone() {
      if (!this.pickMiddleNumber) return;
      interact("#dropzone5").unset();
    },
    // End of set dropzone

    /** Reset */
    resetCrossTable() {
      const middleDropzone = document.getElementsByClassName(
        "dropzone-drop-middle"
      )[0];
      const numberBlocksEl = document.getElementsByClassName(
        "app-number-block"
      );
      for (let el of numberBlocksEl) {
        el.classList.remove("dropped");
      }
      middleDropzone.textContent = "";
    },
  },
  mounted() {
    if (!this.pickMiddleNumber) return;
    this.setDraggable();
    this.setDropzone();
  },
  destroyed() {
    this.unsetDraggable();
    this.unsetDropzone();
  },
};
</script>

<style scoped>
.dropzone {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 35px;
  height: 55px;
  width: 55px;
  padding: 0;
  margin: 5px;
}
.functionzone {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 35px;
  height: 55px;
  width: 55px;
  padding: 0;
  margin: 1vw;
  text-align: center;
}
.drop-active {
  border-color: #aaa;
}

.drop-target {
  background-color: #4e4;
}
.dropped {
  background: #eeeeee;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 25px;
  height: 45px;
  width: 45px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  border: solid 1px #7f8c8d;
  border-radius: 0.4vw;
  text-align: center;
}
</style>